/**
 * Formatting utility functions for the PriceSpy dashboard
 */

/**
 * Convert an ISO date string to a human-readable relative time string
 */
export function getRelativeTime(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSec = Math.floor(diffMs / 1000)
  const diffMin = Math.floor(diffSec / 60)
  const diffHr = Math.floor(diffMin / 60)
  const diffDays = Math.floor(diffHr / 24)

  if (diffSec < 60) return 'just now'
  if (diffMin < 60) return `${diffMin}m ago`
  if (diffHr < 24) return `${diffHr}h ago`
  if (diffDays < 7) return `${diffDays}d ago`
  return date.toLocaleDateString()
}

/**
 * Extract the hostname from a URL string. Returns the original string on invalid URL.
 */
export function getDomainFromUrl(url: string): string {
  try {
    return new URL(url).hostname
  } catch {
    return url
  }
}

/**
 * Convert a snake_case change type to a human-readable string with spaces
 */
export function formatChangeType(changeType: string): string {
  return changeType.replace(/_/g, ' ')
}
